import { React, DomeComponent, DomeManipulator, DomeRouter } from "@lexriver/dome";
import css from './BasketTop.m.scss'
import { GlobalState } from "../GlobalState";
import cssAnimation from '../Animation.m.scss'
import { JsonBasketStats } from "../json-data-types/JsonBasketStats";
import { GlobalBasket } from "../GlobalBasket";
import { GlobalRightSidebar } from "../GlobalRightSidebar";
import { IBasket } from "../Basket/IBasket";

interface Attrs{

}

export class BasketTop extends DomeComponent<Attrs>{
    //counter:number = 0
    refContainer!:HTMLDivElement

    render(){
        return (
            <div class={css.container} ref={ref => { this.refContainer = ref; }} onClick={() => GlobalRightSidebar.showAsync()}></div>
        )
    }
    async afterRender(){
        GlobalState.basketSmallDiv = this.rootElement as HTMLDivElement
        

        //console.log('### BasketSmall afterRender subscribing to basket-update!')
        GlobalBasket.onBasketUpdateEvent.subscribe(async () => {
            //console.log('### BasketSmall onBasketUpdateEvent!')
            if(!DomeManipulator.isInDom(this.rootElement)) return {unsubscribe:true}
            this.scheduleUpdate()
        })

        GlobalBasket.onBasketEmptyOrFullEvent.subscribe(() => {
            //this.scheduleUpdate()
        })

        GlobalBasket.onBasketStatsEvent.subscribe(async (basketStats) => {
            // console.log('BasketTop.tsx BasketStats event', basketStats)

            await DomeManipulator.replaceAllChildrenAsync(
                this.refContainer, 
                await this.renderBasketStatsAsync(basketStats),
                undefined,
                {cssClassName:cssAnimation.basketHeader, timeMs: 300}
                )
        
        })


        this.scheduleUpdate()

    }

    async updateAsync(){
        //this.counter++
        const basket:IBasket = await GlobalBasket.getCurrentBasketAsync()
        const cBasketStats = await basket.getStatsAsync({getJsonOrderItems:false})
        //console.log('))) cBasketStats=', cBasketStats)
        
        
        await DomeManipulator.replaceAllChildrenAsync(
            this.refContainer, 
            await this.renderBasketStatsAsync(cBasketStats),
            undefined,
            {cssClassName:cssAnimation.basketHeader, timeMs: 300}
            )
        
    }

    async renderBasketStatsAsync(basketStats: JsonBasketStats){
        return (
            <div class={css.basket}>
                {/* <div>counter={this.counter}</div> */}
                <span class="icon-shopping-basket" style={{ fontSize: "20px", margin: '0 3px' }}  ></span>
                {basketStats.totalQuantity === 0 
                    //? <div>Добавьте товар</div>
                    ? <></>
                    : <>
                        <div class={css.counter}>{basketStats.totalQuantity}</div>
                        {/* {GlobalUser.checkIfCanSeeWholesalePrices()
                            ? <div class={css.sumContainer}>{Settings.formatNumberToPrice(basketStats.wholesaleSum)}</div>
                            : <div class={css.sumContainer}>{Settings.formatNumberToPrice(basketStats.retailSum)}</div>
                        } */}
                    </>
                }
            </div>
                
        )

    }
    
}

